import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'icheck/skins/square/green.css';
import 'animate.css/animate.min.css';
import 'rc-tree/assets/index.css';
import './css/style.css';
import './css/custom.css';

import 'jquery/dist/jquery.min';
import 'bootstrap/dist/js/bootstrap.min';
import 'metismenu/dist/metisMenu.min';
